import {ReactNode} from 'react';
import {Navigate, useLocation} from "react-router-dom";
import {PlatformLoader} from '@flexinet/ui-components';
import {useAuth} from "../hooks/useAuth.ts";

// FNP-1718 / FNP-1416: a route guard that can tell "not signed in" from "not
// known yet". It reads `status`, never `user`.
//
// ⚠️ THE BUG THIS PREVENTS. `user` is null until getCurrentUser() answers, so
// `if (!user) return <Navigate to="/"/>` redirected on the first render of
// every typed URL, reload and bookmark. "/" then sent the signed-in user on to
// /dashboard, and the page they asked for was lost. Clicking through the menu
// worked, because by then `user` was set — which is why it looked like a
// permissions problem on one page rather than a guard problem on all of them.
// Same shape as RequirePermission (FNP-1359) and the skeleton (FNP-1501).
export const RequireAuth = ({children}: { children: ReactNode }) => {

    const {status} = useAuth();
    const location = useLocation();

    if (status === 'resolving') {
        return <PlatformLoader message='Signing in...'/>;
    }

    if (status === 'anonymous') {
        return <Navigate to="/" replace state={{from: location}}/>;
    }

    return children;
};
